import { StyleSheet, Text, View } from "react-native";
import React from "react";
import Layout from "~components/atoms/Layout/index.web";

const CreateContact = () => {
  return (
    <Layout>
      <Text>CreateContact</Text>
    </Layout>
  );
};

export default CreateContact;

const styles = StyleSheet.create({});
